<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backTo' | translate }} {{ 'class' | translate }}</a>

  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'chat' | translate }}</h1>
      <p class="st-subtitle">{{ studentList.length }} {{ 'students' | translate }}</p>
    </div>
    <span class="scd-class-badge" *ngIf="className"><i class="ri-building-line"></i> {{ className }}</span>
  </div>

  <div class="scd-chat-wrap" [class.scd-conversation-open]="selectedStudent || switchingConversation">
    <!-- ============ Left pane: student list ============ -->
    <div class="st-card scd-list-pane">
      <div class="scd-search-row">
        <i class="ri-search-line"></i>
        <input type="text" class="scd-search-input" [(ngModel)]="searchQuery"
               placeholder="{{ 'searchByNameOrMessage' | translate }}" />
      </div>

      <div class="scd-filter-tabs">
        <button type="button" class="scd-filter-tab" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">{{ 'all' | translate }}</button>
        <button type="button" class="scd-filter-tab" [class.active]="activeFilter === 'UNREAD'" (click)="setFilter('UNREAD')">{{ 'unread' | translate }}</button>
      </div>

      <div class="scd-chat-list-card" *ngIf="!loading && filteredStudentList.length">
        <div class="scd-chat-thread-row" *ngFor="let s of filteredStudentList" [class.active]="selectedStudent?.studentId === s.studentId" (click)="openConversation(s)">
          <div class="st-avatar" [class.sd-avatar-photo]="s.studentImage">
            <img *ngIf="s.studentImage && s.studentImage !== '/images/placeholder.png'" [src]="s.studentImage" alt="{{ s.studentName }}" />
            <ng-container *ngIf="!s.studentImage || s.studentImage === '/images/placeholder.png'">{{ s.studentName?.charAt(0) }}</ng-container>
          </div>
          <div class="st-list-text">
            <div class="st-list-title">{{ s.studentName }} {{ s.surname }}</div>
            <div class="st-list-sub scd-chat-preview">
              <i class="ri-check-double-line scd-status-icon read" *ngIf="!s.isTyping && showsStatusIcon(s) && s.IsRead === 1"></i>
              <i class="ri-check-line scd-status-icon sent" *ngIf="!s.isTyping && showsStatusIcon(s) && s.IsRead !== 1"></i>
              <span class="scd-typing-text" *ngIf="s.isTyping">{{ 'typingEllipsis' | translate }}</span>
              <span *ngIf="!s.isTyping">{{ s.message || ('noMessagesYet' | translate) }}</span>
            </div>
          </div>
          <div class="scd-chat-thread-meta">
            <span class="sh-time" *ngIf="s.timeStamp">{{ formatTime(s.timeStamp) }}</span>
            <span class="sh-unread-badge" *ngIf="s.unreadCount > 0">{{ unreadDisplay(s.unreadCount) }}</span>
          </div>
        </div>
      </div>

      <div class="st-empty-state" *ngIf="!loading && !filteredStudentList.length">
        <i class="ri-chat-3-line"></i>
        {{ 'noStudentFound' | translate }}
      </div>

      <div class="scd-chat-list-card" *ngIf="loading">
        <div class="scd-chat-thread-row" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="scd-skeleton scd-skeleton-avatar"></div>
          <div class="st-list-text">
            <div class="scd-skeleton scd-skeleton-line scd-skeleton-line-title"></div>
            <div class="scd-skeleton scd-skeleton-line scd-skeleton-line-sub"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ Right pane: conversation thread ============ -->
    <div class="st-card scd-chat-card">
      <ng-container *ngIf="selectedStudent; else scdNoConversation">
        <div class="scd-chat-thread-head">
          <button type="button" class="scd-back-btn" (click)="closeConversation()"><i class="ri-arrow-left-line"></i></button>
          <div class="st-avatar" [class.sd-avatar-photo]="selectedStudent.studentImage">
            <img *ngIf="selectedStudent.studentImage && selectedStudent.studentImage !== '/images/placeholder.png'" [src]="selectedStudent.studentImage" alt="{{ selectedStudent.studentName }}" />
            <ng-container *ngIf="!selectedStudent.studentImage || selectedStudent.studentImage === '/images/placeholder.png'">{{ selectedStudent.studentName?.charAt(0) }}</ng-container>
          </div>
          <div class="st-list-text">
            <div class="st-list-title">
              {{ selectedStudent.studentName }} {{ selectedStudent.surname }}
              <span class="scd-presence-dot" [class.online]="userOnline"></span>
            </div>
            <div class="st-list-sub scd-chat-subtitle">
              <span *ngIf="!isTyping">{{ (userOnline ? 'online' : 'offline') | translate }}</span>
              <span class="scd-typing-text" *ngIf="isTyping">{{ 'typingEllipsis' | translate }}</span>
            </div>
          </div>
        </div>

        <div class="scd-chat-messages" id="scd-chat-scroll" (scroll)="onMessagesScroll($event)">
          <div class="scd-load-more" *ngIf="paginationLoading">
            <i class="ri-loader-4-line ri-spin"></i>
          </div>

          <div class="st-empty-state" *ngIf="conversationLoading">
            <i class="ri-loader-4-line ri-spin"></i>
            {{ 'loadingMessages' | translate }}
          </div>

          <ng-container *ngIf="!conversationLoading">
            <ng-container *ngFor="let bucket of chatBuckets; trackBy: trackByBucketDate">
              <div class="scd-date-divider"><span>{{ dayLabelFor(bucket.date) }}</span></div>
              <div class="scd-chat-bubble-row" *ngFor="let m of bucket.messages; trackBy: trackByMessageUid" [class.self]="isOwnMessage(m.fromUserId)">
                <div class="scd-chat-bubble" [class.self]="isOwnMessage(m.fromUserId)">
                  <div class="scd-chat-text">{{ m.message }}</div>
                  <div class="scd-chat-time">
                    {{ formatTime(m.timeStamp) }}
                    <i class="ri-time-line scd-status-icon pending" *ngIf="messageStatus(m) === 'pending'"></i>
                    <i class="ri-check-line scd-status-icon sent" *ngIf="messageStatus(m) === 'sent'"></i>
                    <i class="ri-check-double-line scd-status-icon read" *ngIf="messageStatus(m) === 'read'"></i>
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="st-empty-state" *ngIf="!chatBuckets.length && !isTyping">
              <i class="ri-chat-3-line"></i>
              {{ 'noMessagesYetSayHello' | translate }}
            </div>

            <div class="scd-chat-bubble-row" *ngIf="isTyping">
              <ng-lottie [options]="typingAnimationOptions" class="scd-typing-animation"></ng-lottie>
            </div>
          </ng-container>
        </div>

        <div class="scd-chat-exceeded" *ngIf="chatExceeded">
          <i class="ri-error-warning-line"></i> {{ chatExceededMessage }}
        </div>

        <div class="scd-chat-input-row" *ngIf="!chatExceeded">
          <input type="text" class="scd-chat-input" placeholder="{{ 'writeAMessageTo' | translate }} {{ selectedStudent.studentName }}"
                 [(ngModel)]="chatMessage" (input)="onTyping()" (keyup.enter)="sendMessage()" />
          <button class="st-btn st-btn-primary" [disabled]="!chatMessage || !chatMessage.trim()" (click)="sendMessage()">
            <i class="ri-send-plane-line"></i>
          </button>
        </div>
      </ng-container>

      <ng-template #scdNoConversation>
        <div class="scd-no-conversation" *ngIf="!switchingConversation">
          <i class="ri-chat-3-line"></i>
          <p>{{ 'selectAConversationToStart' | translate }}</p>
        </div>
        <div class="scd-no-conversation" *ngIf="switchingConversation">
          <i class="ri-loader-4-line ri-spin"></i>
          <p>{{ 'loadingEllipsis' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
